<template>
  <v-app>
    <v-content>
      <calculate-module />
    </v-content>
  </v-app>
</template>

<script>
import calculate from '@/components/calculate';

export default {
  name: 'App',
  components: {
    'calculate-module': calculate
  },
}
</script>
